import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './app/App.tsx'
import { installStaleBuildRecovery } from './app/staleBuild.ts'
import './index.css'
import { installProblemReporting } from './lib/telemetry.ts'

installProblemReporting()
installStaleBuildRecovery()

const root = document.getElementById('root')
if (!root) throw new Error('#root is missing from app.html')

createRoot(root).render(
	<StrictMode>
		<App />
	</StrictMode>,
)
